import React, {FC} from 'react';
import styles from '../draftUsers.module.scss';
import TooltipAndLabel from "../../../../uiComponents/Tooltip/Tooltip";
import {CSV_HEAD_TOOLTIPS} from "../../BulkUploadUsers/constants";

interface TTableHeadProps {
    columnsConfig: { key: string; label: string, tooltip?: string }[];
}

const TableHead: FC<TTableHeadProps> = ({columnsConfig}) => {
    return (
        <thead>
        <tr>
            {
                columnsConfig.map((item, index) => {
                    const tooltip = item.tooltip || CSV_HEAD_TOOLTIPS[item.key];
                    return (
                        <th key={index} className={styles.tableHead}>
                            <div className={styles.tableHeadContent}>
                                <span>
                                    {item.label}
                                </span>
                                {
                                    tooltip && (
                                        <TooltipAndLabel
                                            tooltipMessage={tooltip}
                                        />
                                    )
                                }
                            </div>
                        </th>
                    )
                })
            }
            <th className={styles.tableHead}/>
        </tr>
        </thead>
    )
}

export default TableHead;
